import { useContext } from 'react';

import { MultiTaskHandlersContext } from './multi-task-handlers-context';

export const useOpenDeleteTasksDialog = () => {
  const { openDeleteTasks } = useContext(MultiTaskHandlersContext);
  return openDeleteTasks;
};
